import { useDataExplorerAppearance } from './appearanceContext';
import { DataExplorerToolbarActions } from './DataExplorerToolbarActions';
import { resolveDataExplorerAppearance } from './theme';
import type { DataExplorerActionBarProps } from './types';
import { cn } from './utils';

export function DataExplorerActionBar<TContext = unknown>({
  context,
  actions = [],
  leading,
  trailing,
  children,
  empty,
  appearance,
  className,
  classNames,
}: DataExplorerActionBarProps<TContext>) {
  const theme = resolveDataExplorerAppearance(
    useDataExplorerAppearance(appearance),
  );

  const hasContent =
    !!leading || !!trailing || !!children || actions.length > 0;
  const hasRenderableContent = hasContent || !!empty;

  if (!hasRenderableContent) {
    return null;
  }

  return (
    <div
      className={cn(
        theme.slots.actionBarRoot,
        classNames?.root,
        className,
      )}
    >
      {leading ? (
        <div className={cn(theme.slots.actionBarLeading, classNames?.leading)}>
          {leading}
        </div>
      ) : null}

      <DataExplorerToolbarActions
        context={context}
        actions={actions}
        layout="action-bar"
        appearance={appearance}
        empty={!hasContent ? empty : undefined}
        classNames={{
          root: classNames?.actions,
          action: classNames?.action,
        }}
      >
        {children}
      </DataExplorerToolbarActions>

      {trailing ? (
        <div className={cn(theme.slots.actionBarTrailing, classNames?.trailing)}>
          {trailing}
        </div>
      ) : null}
    </div>
  );
}
